import { render, staticRenderFns } from "./PostFormEdit.vue?vue&type=template&id=21e0f52c&scoped=true"
import script from "./PostFormEdit.vue?vue&type=script&lang=js"
export * from "./PostFormEdit.vue?vue&type=script&lang=js"
import style0 from "./PostFormEdit.vue?vue&type=style&index=0&id=21e0f52c&prod&scoped=true&lang=css"
import style1 from "./PostFormEdit.vue?vue&type=style&index=1&id=21e0f52c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e0f52c",
  null
  
)

export default component.exports